import React, { useEffect, useState } from 'react'
import * as API from "../../framework/API/api"
import { ASSETTYPE, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { ImageCell } from '../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { ConfirmAlertOk, ConfirmDeleteAlert } from '../../ConfirmAlert';
import { ProviderCell } from '../../framework/forms/helpercomponents/CustomGridCells/ProviderCell';
import ToastNotification from '../../components/ToastNotification';

const MusicPlaylistEditForm = ({ item, cancelEdit, refresh }) => {

    const lang = useTranslation();

    const blankDataItem = {
        Name: "",
        Description: "",
        Archive: false,
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [openOttAsset, setOpenOttAsset] = useState(false);

    useEffect(() => {
        if (item?._id) loadEditData()
    }, []);

    const loadEditData = async () => {
        let linkData = {
            link_collection: ENTITYNAME.OttAsset,
            link_field: 'Ott_Assets'
        }
        let res = await API.getEntity(ENTITYNAME.MusicPlaylist, parseInt(item?.SID), linkData);
        if (res.success) {
            let data = {
                ...res.data,
                Name: res?.data?.Name ?? "",
                Description: res?.data?.Description ?? "",
                Archive: res?.data?.Archive ?? false,
            }
            setDataItem(data);
            setGridData(res?.data?.Ott_Assets ?? [])
        }
    }

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (dataItem.Name == undefined || dataItem.Name == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (dataItem.Description == undefined || dataItem.Description == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        return true;

    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Name: dataItem?.Name,
            Description: dataItem?.Description,
            Ott_Assets: gridData?.length > 0 ? gridData.map(x => x?._id) : [],
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["Name", "=", dataItem.Name]]

        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.MusicPlaylist, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.MUSIC_PLAYLIST, data: res.data, message: res.message };
            API.SaveLogs(logData);
            cancelEdit();
            refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.MusicPlaylist);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const handleOttAssetSelect = (item) => {
        setGridData([...gridData, ...item]);
        setOpenOttAsset(false);
    };

    const musicArrayCell = (props) => {
        const value = props.dataItem[props.field];
        if (typeof value === 'string') {
            return <td>{value}</td>;
        }
        const array = Array.isArray(value) ? value : value ? [value] : [];
        const text = array.map((item) => item?.value || '').filter(Boolean).join(', ');
        return <td>{text}</td>;
    };

    const handleMusicListDelete = (id) => {
        ConfirmDeleteAlert(() => {
            const updated = gridData.filter(item => item?._id !== id);
            setGridData(updated);
        }, () => { });
    };

    const MusicListCommandCell = (props) => (
        <td>
            <RoundButton icon="trash" title={lang.delete_button_tooltip} onClick={() => handleMusicListDelete(props?.dataItem?._id)} />
        </td>
    );

    const handleDeleteAll = () => {
        ConfirmAlertOk(
          () => {
            setGridData([]);
          },
          "Confirm Alert Delete All",
          "Are you sure you want to delete all?",
          "Delete All"
        );
      };

    return (
        <>
            <BossDialog title={item?.Name ?? lang.music_playlist_dialog_header} onClose={cancelEdit} width={"900px"}>
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={cancelEdit} showTitle={false} />
                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <label>{lang.name_label} *</label>
                                <input
                                    name="Name"
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.Name}
                                />
                            </div>
                            <div className='col-6'>
                                <label>{lang.description_label} *</label>
                                <input
                                    name="Description"
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.Description}
                                />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <input
                                    style={{ border: "1px solid grey", marginTop: "26px" }}
                                    name={"Archive"}
                                    type='checkbox'
                                    onChange={onChange}
                                />
                                <label className="ml-2">{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div className="d-flex">
                                <AddRoundButton onClick={() => setOpenOttAsset(true)} />
                                <RoundButton icon="trash" title={lang.delete_all_button_tooltip} onClick={handleDeleteAll} />
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "bold", marginTop: "6px" }}>
                                {lang.music_list_label}
                            </div>
                        </div>
                        <Grid data={gridData} resizable style={{ height: "40vh", marginTop: "10px" }}>
                            <Column editable={false} cell={MusicListCommandCell} width="70px" />
                            <Column field="Posters" title="Poster" cell={ImageCell} width="150px" />
                            <Column field="Title" title="Title" format={"value"} cell={musicArrayCell} width="180px" />
                            <Column field="Description" title="Description" format={"value"} cell={musicArrayCell} width="150px" />
                            <Column field="Provider" title="Provider" width="150px" cell={ProviderCell} />
                            <Column field="VodTypes.Name" title="VodType" />
                        </Grid>
                    </div>
                </div>
                {openOttAsset && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.ott_asset_library_dialog_header} wherestatement={["OttAssetTypeSID", "=", ASSETTYPE.Music]} setDataList={handleOttAssetSelect} entityname={ENTITYNAME.OttAsset} closeForm={() => setOpenOttAsset(false)} mode={'multiple'} width={"60vw"} />}
            </BossDialog >
        </>
    )
}

export default MusicPlaylistEditForm